import Cookies from "js-cookie";

const html = document.getElementsByTagName("html")[0];
const htmlDataset = html ? html.dataset || {} : {};

const isPreview = htmlDataset.isPreview === "true";
const trackingEnabled = htmlDataset.matomoEnabled === "true";

if (
  html &&
  trackingEnabled &&
  !isPreview &&
  Cookies.get("cookieconsent_status") === "allow"
) {
  /* eslint-disable no-undef */
  window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["trackPageView"]);
  _paq.push(["enableLinkTracking"]);

  (function () {
    const u = htmlDataset.matomoUrl;

    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", htmlDataset.matomoSiteId]);

    const g = document.createElement("script");
    g.type = "text/javascript";
    g.async = true;
    g.defer = true;
    g.src = u + "matomo.js";

    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(g, s);
  })();
  /* eslint-enable */
}
